import options from './thing-name.component';

export default {
    selector: 'dtThingDetailsName',
    options
};
